import Layer from './layer';
import Settings from '../settings';
import DataBlock from '../data_block';

var StackBlur = require("stackblur-canvas");
var Buffer = require('buffer').Buffer;
var LZ4 = require('lz4');

export default class CleanLayer extends Layer {
  constructor(page, x, y) {
    super(page);
    this.type = 'clean';

    if (x !== undefined) {
      this.process(x, y);
    }
  }

  process(x, y) {
    if (this.canvas)
      return;

    let image = this.page.source;
    let values = this.page.sourceValues;
    let imageData = this.page.sourceData;
    let w = image.width;
    let h = image.height;


    let clipBounds = this.page.selection || {
      left: 0,
      top: 0,
      right: w - 1,
      bottom: h - 1
    }



    const ACCURACY = Settings.get('clean-accuracy', 7)|0;
    const MARGIN = Settings.get('clean-margin', 2)|0;
    const FILL_STYLE = Settings.get('clean-fill-style', 'simple');
    const BLUR_RADIUS = Settings.get('clean-blur-radius', 10)|0;




    // значения на этапе исследования и заливки:
    // 0 - не исследовано
    // 1 - к исследованию
    // 2 - чисто
    // 3 - граница исследования
    // 10 - внешняя зона (при заливке)
    //
    // значения после финальной обработки:
    // 0 - пусто
    // 1 - балун
    let mask = new Uint8Array(w * h);
    mask[y * w + x] = 1;

    // текущие границы, внутри которых ведется исследование
    let bounds = {
      left: x,
      top: y,
      right: x,
      bottom: y
    };

    let iterate = () => {
      let found = false;

      let newBounds = {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
      }

      for (let i = bounds.left; i <= bounds.right; i++) {
        for (let j = bounds.top; j <= bounds.bottom; j++) {
          let index = j * w + i;
          if (mask[index] != 1)
            continue;

          found = true;

          let value = values[index];
          let foundNeigh = false;

          let qVal = value;
          for (let q = i - 1; q >= clipBounds.left; q--) {
            const qIndex = j * w + q;
            if (mask[qIndex] != 0) {
              foundNeigh = true;
              break;
            }

            if (Math.abs(values[qIndex] - qVal) <= ACCURACY) {
              mask[qIndex] = 1;
              foundNeigh = true;
              qVal = values[qIndex];

              newBounds.left = Math.min(newBounds.left, q);
            } else break;
          }

          qVal = value;
          for (let q = i + 1; q <= clipBounds.right; q++) {
            const qIndex = j * w + q;
            if (mask[qIndex] != 0) {
              foundNeigh = true;
              break;
            }

            if (Math.abs(values[qIndex] - qVal) <= ACCURACY) {
              mask[qIndex] = 1;
              foundNeigh = true;
              qVal = values[qIndex];

              newBounds.right = Math.max(newBounds.right, q);
            } else break;
          }

          qVal = value;
          for (let q = j - 1; q >= clipBounds.top; q--) {
            const qIndex = q * w + i;
            if (mask[qIndex] != 0) {
              foundNeigh = true;
              break;
            }

            if (Math.abs(values[qIndex] - qVal) <= ACCURACY) {
              mask[qIndex] = 1;
              foundNeigh = true;
              qVal = values[qIndex];

              newBounds.top = Math.min(newBounds.top, q);
            } else break;
          }

          qVal = value;
          for (let q = j + 1; q <= clipBounds.bottom; q++) {
            const qIndex = q * w + i;
            if (mask[qIndex] != 0) {
              foundNeigh = true;
              break;
            }

            if (Math.abs(values[qIndex] - qVal) <= ACCURACY) {
              mask[qIndex] = 1;
              foundNeigh = true;
              qVal = values[qIndex];

              newBounds.bottom = Math.max(newBounds.bottom, q);
            } else break;
          }

          if (!foundNeigh) {
            mask[index] = 3;
          } else {
            mask[index] = 2;
          }
        }
      }

      bounds = newBounds;

      return found;
    }

    if (this.page.zones) {
      let zoneIndex = this.page.zones[y * w + x];
      for (let i = 0; i < w * h; i++) {
        if (this.page.zones[i] != zoneIndex)
          continue;
        mask[i] = 2;
        bounds.left = Math.min(bounds.left, i % w);
        bounds.right = Math.max(bounds.right, i % w);
        bounds.top = Math.min(bounds.top, Math.floor(i / w));
        bounds.bottom = Math.max(bounds.bottom, Math.floor(i / w));
      }
    } else {
      while(iterate()) {}
    }



    // preMask - состояние mask на текущий момент (до заливки)
    // нужно для умной заливки
    // 1 - фон балуна, 0 - снаружи или буквы
    let preMask = new Uint8Array(mask.length);
    preMask.set(mask);



    bounds.left = Math.max(0, bounds.left - 1);
    bounds.right = Math.min(w - 1, bounds.right + 1);
    bounds.top = Math.max(0, bounds.top - 1);
    bounds.bottom = Math.min(h - 1, bounds.bottom + 1);

    for (let i = bounds.left; i <= bounds.right; i++) {
      if (mask[bounds.top * w + i] == 0) {
        mask[bounds.top * w + i] = 10;
      }
      if (mask[bounds.bottom * w + i] == 0) {
        mask[bounds.bottom * w + i] = 10;
      }
    }

    for (let i = bounds.top; i <= bounds.bottom; i++) {
      if (mask[i * w + bounds.left] == 0) {
        mask[i * w + bounds.left] = 10;
      }
      if (mask[i * w + bounds.right] == 0) {
        mask[i * w + bounds.right] = 10;
      }
    }

    let fillOuter = () => {
      let found = false;

      for (let i = bounds.left; i <= bounds.right; i++) {
        for (let j = bounds.top; j <= bounds.bottom; j++) {
          if (mask[j * w + i] != 0)
            continue;

          if (
            (i > 0 && mask[j * w + i - 1] == 10) ||
            (i < w - 1 && mask[j * w + i + 1] == 10) ||
            (j > 0 && mask[(j - 1) * w + i] == 10) ||
            (j < h - 1 && mask[(j + 1) * w + i] == 10)
          ) {
            mask[j * w + i] = 10;
            found = true;
          }
        }
      }

      return found;
    }

    while (fillOuter()) {}






    // финальная обработка
    let finish = () => {
      for (let i = bounds.left; i <= bounds.right; i++) {
        for (let j = bounds.top; j <= bounds.bottom; j++) {
          mask[j * w + i] = (mask[j * w + i] == 10) ? 0 : 1;
        }
      }
    }

    finish();






    let iterateMargin = () => {
      for (let i = bounds.left; i <= bounds.right; i++) {
        for (let j = bounds.top; j <= bounds.bottom; j++) {
          if (mask[j * w + i] != 1)
            continue;

          if (
            (i > 0 && mask[j * w + i - 1] == 0) ||
            (i < w - 1 && mask[j * w + i + 1] == 0) ||
            (j > 0 && mask[(j - 1) * w + i] == 0) ||
            (j < h - 1 && mask[(j + 1) * w + i] == 0)
          ) {
            mask[j * w + i] = 10;
          }
        }
      }

      for (let i = bounds.left; i <= bounds.right; i++) {
        for (let j = bounds.top; j <= bounds.bottom; j++) {
          if (mask[j * w + i] == 10) {
            mask[j * w + i] = 0;
          }
        }
      }
    }

    for (let i = 0; i < MARGIN; i++)
      iterateMargin();



    let diffColors = (color1, color2) => {
      return Math.max(
        Math.abs(color1[0] - color2[0]),
        Math.abs(color1[1] - color2[1]),
        Math.abs(color1[2] - color2[2])
      );
    }

    let smartFill = (newData) => {
      let sourceIndex = (y * w + x);
      let sourceValue = values[sourceIndex];
      let sourceColor = new Uint8Array(4);
      sourceIndex *= 4;
      sourceColor[0] = imageData.data[sourceIndex + 0];
      sourceColor[1] = imageData.data[sourceIndex + 1];
      sourceColor[2] = imageData.data[sourceIndex + 2];
      sourceColor[3] = imageData.data[sourceIndex + 3];

      let fillMask = new Uint8Array(this.width * this.height);
      for (let i = 0; i < this.width; i++) {
        for (let j = 0; j < this.height; j++) {
          let indexS = (this.y + j) * w + this.x + i;

          let index = (j * this.width + i);
          if (preMask[indexS]) {
            fillMask[index] = 1;

            index *= 4;
            indexS *= 4;
            newData.data[index + 0] = imageData.data[indexS + 0];
            newData.data[index + 1] = imageData.data[indexS + 1];
            newData.data[index + 2] = imageData.data[indexS + 2];
            newData.data[index + 3] = imageData.data[indexS + 3];
          } else {
            fillMask[index] = 2;
          }
        }
      }

      let foundCountOld = 0;
      let fillMaskOld = new Uint8Array(this.width * this.height);

      while(true) {
        let foundCount = 0;
        fillMaskOld.set(fillMask);

        for (let i = 0; i < this.width; i++) {
          for (let j = 0; j < this.height; j++) {
            if (fillMaskOld[j * this.width + i] != 2)
              continue;

            foundCount += 1;

            let r = 0, g = 0, b = 0, a = 0;
            let count = 0;

            const outerSize = 1;
            for (let di = -outerSize; di <= outerSize; di++) {
              if (i + di < 0 || i + di >= this.width)
                continue;

              for (let dj = -outerSize; dj <= outerSize; dj++) {
                if (j + dj < 0 || j + dj >= this.height)
                  continue;

                let index = (j + dj) * this.width + i + di;
                if (fillMaskOld[index] != 1)
                  continue;

                index *= 4;
                r += newData.data[index + 0];
                g += newData.data[index + 1];
                b += newData.data[index + 2];
                a += newData.data[index + 3];
                count += 1;
              }
            }

            if (count > 2) {
              let index = j * this.width + i;

              fillMask[index] = 1;
              index *= 4;
              newData.data[index + 0] = Math.floor(r / count);
              newData.data[index + 1] = Math.floor(g / count);
              newData.data[index + 2] = Math.floor(b / count);
              newData.data[index + 3] = Math.floor(a / count);
            }
          }
        }

        if (foundCount == 0 || foundCount == foundCountOld)
          break;
        foundCountOld = foundCount;
      }

      for (let i = 0; i < this.width; i++) {
        for (let j = 0; j < this.height; j++) {
          let index = j * this.width + i;
          if (fillMask[index] != 2)
            continue;

          index *= 4;

          newData.data[index + 0] = sourceColor[0];
          newData.data[index + 1] = sourceColor[1];
          newData.data[index + 2] = sourceColor[2];
          newData.data[index + 3] = sourceColor[3];
        }
      }



      const radius = BLUR_RADIUS|0;
      if (radius > 0) {
        StackBlur.imageDataRGBA(newData, 0, 0, this.width, this.height, radius);
      }


      for (let i = 0; i < this.width; i++) {
        for (let j = 0; j < this.height; j++) {
          let indexS = (this.y + j) * w + this.x + i;
          if (mask[indexS])
            continue;

          let index = (j * this.width + i) * 4;

          newData.data[index + 0] = 0;
          newData.data[index + 1] = 0;
          newData.data[index + 2] = 0;
          newData.data[index + 3] = 0;
        }
      }
    }




    let sourceIndex = (y * w + x) * 4;
    let sourceColor = new Uint8Array(4);
    sourceColor[0] = imageData.data[sourceIndex + 0];
    sourceColor[1] = imageData.data[sourceIndex + 1];
    sourceColor[2] = imageData.data[sourceIndex + 2];
    sourceColor[3] = imageData.data[sourceIndex + 3];
    //sourceColor[0] = 0;sourceColor[1] = 255;sourceColor[2]=0;sourceColor[3]=255;




    this.mask = mask;

    this.x = bounds.left;
    this.y = bounds.top;
    this.width = bounds.right - bounds.left + 1;
    this.height = bounds.bottom - bounds.top + 1;

    this.canvas = document.createElement('canvas');
    this.canvas.width = this.width;
    this.canvas.height = this.height;

    let ctx = this.canvas.getContext('2d');
    let newData = ctx.createImageData(this.width, this.height);

    if (FILL_STYLE == 'smart') {
      smartFill(newData);
    } else {
      for (let i = 0; i < this.width; i++) {
        for (let j = 0; j < this.height; j++) {
          let x = i + this.x;
          let y = j + this.y;

          if (mask[y * w + x] != 1)
            continue;

          let index = (j * this.width + i) * 4;
          newData.data[index + 0] = sourceColor[0];
          newData.data[index + 1] = sourceColor[1];
          newData.data[index + 2] = sourceColor[2];
          newData.data[index + 3] = sourceColor[3];
        }
      }
    }

    ctx.putImageData(newData, 0, 0);
  }

  exportBinary() {
    let input = new Buffer(this.mask);
    let output = new Buffer(LZ4.encodeBound(input.length));
    let compressedSize = LZ4.encodeBlock(input, output);

    output = output.slice(0, compressedSize);

    let extra = new DataBlock();
    extra.put4(this.mask.length);
    extra.putArray(output);
    return this.__exportBinary(extra);
  }
}
